// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"166":"77e0b9dc","549":"792f7071","569":"e5e57dec","992":"3b4fc511"}[chunkId] + ".chunk.js";
};